(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
      
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      // 👇 Ajout pour la synchronisation
      document.documentElement.style.setProperty('--header-visible-height', `${this.header.offsetHeight}px`);
    }
    
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    
    hide() {
      if (this.headerIsAlwaysSticky && window.innerWidth >= 990) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      
      if (window.innerWidth < 990) {
        const mainHeader = this.header.querySelector('.header-wrapper');
        if (mainHeader) {
          const heightToHide = mainHeader.offsetHeight; 
          this.header.style.setProperty('transform', `translateY(-${heightToHide}px)`, 'important');
        }
      }
      // 👇 MAGIE : On dit à la page que le header prend 0px d'espace car il est caché
      document.documentElement.style.setProperty('--header-visible-height', '0px');
    }
    
    reveal() {
      if (this.headerIsAlwaysSticky && window.innerWidth >= 990) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      
      if (window.innerWidth < 990) {
        this.header.style.setProperty('transform', 'translateY(0)', 'important');
      }
      // 👇 MAGIE : Le header est de retour, on redonne sa vraie hauteur
      document.documentElement.style.setProperty('--header-visible-height', `${this.header.offsetHeight}px`);
    }
    
    reset() {
      if (this.headerIsAlwaysSticky && window.innerWidth >= 990) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      
      if (window.innerWidth < 990) {
        this.header.style.removeProperty('transform');
      }
      // 👇 MAGIE : Reset à la hauteur normale
      document.documentElement.style.setProperty('--header-visible-height', `${this.header.offsetHeight}px`);
    }
    
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }
  
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
